import { combineReducers } from "redux";
import app from "./app";
import dialog from "./dialog";
export const combinedReducer = combineReducers({
    app,
    dialog,
});
